import { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { Button } from '@/common/ui/Form/Button'
import { Fieldset } from '@/common/ui/Form/Fieldset'
import { Input, Select } from '@/common/ui/Form'
import { useAddOrgInvitation } from '../models'
import { cn } from '@/common/lib/cn/cn'
import type { MembershipRole } from '@/common/api/client/types.gen'

const roles: Record<MembershipRole, string> = {
    owner: 'Владелец',
    admin: 'Администратор',
    manager: 'Менеджер',
    member: 'Участник',
    viewer: 'Наблюдатель',
}

export const AddOrgInvitationForm = ({ className }: { className?: string }) => {
    const { form, handleSubmit, onSubmit, register, isPending, isSuccess, isError, error } = useAddOrgInvitation()
    console.log('isError', isError, 'error', error)

    useEffect(() => {
        if (isSuccess) {
            form.reset()
            const checkbox = document.getElementById('addOrgInvitationModal') as HTMLInputElement

            if (checkbox) {
                checkbox.checked = false
            }
        }
    }, [isSuccess, form])

    return (
        <>
            <form method='post' className={cn('modal-form', className)} onSubmit={handleSubmit(onSubmit)}>
                <div className='modal-form-fields'>
                    <div className='modal-form-field'>
                        <Fieldset errorText={form.formState.errors.email?.message} required>
                            <Input
                                className='w-full'
                                size='lg'
                                placeholder='Введите email участника'
                                type='text'
                                {...register('email', {
                                    required: 'Введите email участника',
                                })}
                            />
                        </Fieldset>
                    </div>

                    <div className='modal-form-field'>
                        <Fieldset errorText={form.formState.errors.role?.message} required>
                            <Controller
                                name='role'
                                control={form.control}
                                rules={{ required: 'Выберите роль участника' }}
                                render={({ field }) => (
                                    <Select
                                        className='w-full'
                                        size='lg'
                                        placeholder='Выберите роль участника'
                                        {...field}
                                    >
                                        {Object.entries(roles).map(([key, value]) => (
                                            <option key={key} value={key}>
                                                {value}
                                            </option>
                                        ))}
                                    </Select>
                                )}
                            />
                        </Fieldset>
                    </div>
                </div>
                <div className='modal-form-actions'>
                    <Button
                        className='w-full'
                        emphasis='accent'
                        size='xl'
                        type='submit'
                        disabled={isPending}
                        loading={isPending}
                    >
                        Отправить приглашение
                    </Button>
                    <Button
                        as='label'
                        htmlFor='addOrgInvitationModal'
                        className='w-full'
                        emphasis='secondary'
                        size='lg'
                        variant='ghost'
                    >
                        Отмена
                    </Button>
                </div>
            </form>
        </>
    )
}
